import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from "react";
import { QuickLinksProvider } from "./QuickLinksConfigurationContext/QuickLinksConfigurationContext";
import { QuickLinksGroup } from "./QuickLinksGroup/QuickLinksGroup";
import styles from "./QuickLinks.module.scss";
export const QuickLinks = ({ children, onClick = () => undefined }) => {
    Children.forEach(children, (child) => {
        if (!child) {
            return;
        }
        if (child.type !== QuickLinksGroup) {
            throw new Error("QuickLinks component only accepts QuickLinksGroup components as children");
        }
    });
    return (_jsx(QuickLinksProvider, { onClick: onClick, children: _jsx("div", { "data-testid": "quicklinks", className: styles.wrapper, children: children }) }));
};
//# sourceMappingURL=QuickLinks.js.map